import { CertificateGenerationDocumentId } from '~/store/covenants/types.ts';
import type { TDocumentGenerationValidationIssues } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/validation.ts';

export const GENERATABLE_DOCUMENT_IDS = new Set<string>(
  Object.values(CertificateGenerationDocumentId)
);

export const DOCUMENT_GENERATION_LABELS = {
  regenerate: 'Перегенерувати документ',
  save: 'Зберегти',
  generate: 'Згенерувати документ',
  historicalPending: 'Не перевірено',
  required: 'Не заповнено',
  invalid: 'Має помилку',
} as const;

export const EMPTY_DOCUMENT_GENERATION_VALIDATION_ISSUES: TDocumentGenerationValidationIssues = {
  requiredFieldNames: [],
  invalidFieldNames: [],
};

export const isDocumentRegenerationAvailable = (
  documentId: string | number,
  availableToRegenerate: boolean | undefined,
  isReadOnly: boolean
): boolean =>
  !isReadOnly && !!availableToRegenerate && GENERATABLE_DOCUMENT_IDS.has(String(documentId));
